import { render, staticRenderFns } from "./ListDispAnclajePage.vue?vue&type=template&id=60751c4d&scoped=true"
import script from "./ListDispAnclajePage.vue?vue&type=script&lang=js"
export * from "./ListDispAnclajePage.vue?vue&type=script&lang=js"
import style0 from "./ListDispAnclajePage.vue?vue&type=style&index=0&id=60751c4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60751c4d",
  null
  
)

export default component.exports